



















































































































































































































































































import { Project, OtProjectContract } from '@/areas/projects/project-models';
import { FormModalParams, FormModalSizeEnum } from '@/components/global/modal/form-modal-models';
import OtFormModal from '@/components/global/modal/ot-form-modal.vue';
import OtAutocomplete, { IAutocompleteItem } from '@/components/global/ot-autocomplete.vue';
import OtButton, { OtBtnSize, OtBtnStyle, OtBtnType } from '@/components/global/ot-button.vue';
import OtComboBox from '@/components/global/ot-combo-box.vue';
import OtDatePicker from '@/components/global/ot-date-picker.vue';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import OtRadioGroup, { IRadioGroupOption } from '@/components/global/ot-radio-group.vue';
import OtSelect from '@/components/global/ot-select.vue';
import OtTag, { TagStatus } from '@/components/global/ot-tag.vue';
import OtTextField from '@/components/global/ot-text-field.vue';
import OtTextarea from '@/components/global/ot-textarea.vue';
import OtTableHeader from '@/components/global/table/ot-table-header.vue';
import { IExtendedColumnData } from '@/components/global/table/ot-table-models';
import OtTable from '@/components/global/table/ot-table.vue';
import { isInvitableOrReinvitable, UserStatus, UserStatusWithActions } from '@/models/user-models';
import OtApi, { executeApi } from '@/services/api.service';
import {
  PermissionLevel,
  PostCreateInvitationRequestModel,
  PostCreateInvitationUserContextModel,
} from '@/services/generated/api';
import { vxm } from '@/store';
import { OtStatusType, OtUserStatus } from '@/types/status-enums';
import { areSame } from '@/utils/string-utils';
import { blurCombos, IVForm } from '@/utils/type-utils';
import { isEmail } from '@/utils/validation-utils';
import { uniqueId } from 'lodash';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { DocumentDetails } from '../document-models';

/** A project that the current user can associate documents with, and a flag for is this document already associated  */
class SelectableProject {
  public project!: Project;
  public alreadyAssociated = false;
  constructor(params?: Partial<SelectableProject>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

/** A contract that the current user can associate documents with, and a flag for is this document already associated  */
class SelectableContract {
  // TODO do we need project? Feels like we need project so we can have the project name
  public project!: Project;
  public contract!: OtProjectContract;
  public alreadyAssociated = false;
  constructor(params?: Partial<SelectableContract>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

/** For binding to the UI, represents a row with a selected project, the errors */
class AddToProject {
  public key: string = uniqueId();
  public project: IAutocompleteItem<SelectableProject> | null = null;
  public errorMessages: string[] = [];
  constructor(params?: Partial<AddToProject>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

/** For binding to the UI, represents a row with a selected contract, the errors */
class AddToContract {
  public key: string = uniqueId();
  public contract: IAutocompleteItem<SelectableContract> | null = null;
  public errorMessages: string[] = [];
  constructor(params?: Partial<AddToContract>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CreateDocumentAssociationsResult {
  public addToOrganisation = false;
  public addToProjectGids: string[] = [];
  public addToContractGids: string[] = [];
  constructor(params?: Partial<CreateDocumentAssociationsResult>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

const ADD_ORGANISATION_NO: IRadioGroupOption = {
  key: '1',
  label: 'No',
};
const ADD_ORGANISATION_YES: IRadioGroupOption = {
  key: '2',
  label: 'Yes',
};
const ADD_PROJECT_NO: IRadioGroupOption = {
  key: '1',
  label: 'No, do not add any project associations',
};
const ADD_PROJECT_YES: IRadioGroupOption = {
  key: '2',
  label: 'Yes, add this document to one or more projects',
};
const ADD_CONTRACT_NO: IRadioGroupOption = {
  key: '1',
  label: 'No, do not create any contract associations',
};
const ADD_CONTRACT_YES: IRadioGroupOption = {
  key: '2',
  label: 'Yes, add this document to one or more contracts',
};

@Component({
  components: {
    OtFormModal,
    OtButton,
    OtTextField,
    OtTextarea,
    OtSelect,
    OtAutocomplete,
    OtDatePicker,
    OtComboBox,
    OtRadioGroup,
    OtTable,
    OtTableHeader,
    OtTag,
    OtLoadingSpinner,
  },
})
export default class OtCreateDocumentAssociations extends Vue {
  // * PROPS
  @Prop({ default: null })
  private documentGid!: string | null;

  @Prop({ default: '' })
  private targetOrganisationGid!: string;

  @Prop({ default: false })
  private addToOrganisation!: boolean;

  @Prop({ default: () => [] })
  private addToProjectGids!: string[];

  @Prop({ default: () => [] })
  private addToContractGids!: string[];

  private api = new OtApi();
  private buttonSize = OtBtnSize.Tiny;
  private buttonStyle = OtBtnStyle.Outline;
  private buttonType = OtBtnType.Icon;

  // * REFS
  @Ref('formRef') private readonly formRef!: IVForm;

  // * DATA
  private selectedOrganisationOption: IRadioGroupOption | null = null;
  private selectedProjectOption: IRadioGroupOption | null = null;
  private selectedContractOption: IRadioGroupOption | null = null;

  /** this is based on the user being an org user for the target org, it has nothing to do with any existing document associations */
  private canAddToTargetOrganisation = false;
  /** this is based on the target org already being associated with the document, it has nothing to do with security checks */
  private isAlreadyAssociatedWithTargetOrganisation = false;

  private availableProjects: IAutocompleteItem<SelectableProject>[] = [];
  private availableContracts: IAutocompleteItem<SelectableContract>[] = [];

  private selectedProjects: AddToProject[] = [];
  private selectedContracts: AddToContract[] = [];

  private showMustSelectSomethingError = false;

  // * COMPUTED

  private get canAddToProjects() {
    return this.availableProjects.length > 0;
  }
  private get canAddToContracts() {
    return this.availableContracts.length > 0;
  }

  private get canAddOrEditOrganisation() {
    return this.canAddToTargetOrganisation && this.isAddToOrganisationYesSelected;
  }
  private get canAddOrEditProjects() {
    return this.canAddToProjects && this.isAddToProjectsYesSelected;
  }
  private get canAddOrEditContracts() {
    return this.canAddToContracts && this.isAddToContractsYesSelected;
  }
  private get showAddToOrganisationAlert() {
    return this.canAddToTargetOrganisation && this.isAlreadyAssociatedWithTargetOrganisation;
  }
  private get showAddToOrganisationSection() {
    return this.canAddToTargetOrganisation && !this.isAlreadyAssociatedWithTargetOrganisation;
  }

  private get organisationOptions(): IRadioGroupOption[] {
    return [ADD_ORGANISATION_NO, ADD_ORGANISATION_YES];
  }

  private get projectOptions(): IRadioGroupOption[] {
    return [ADD_PROJECT_NO, ADD_PROJECT_YES];
  }

  private get contractOptions(): IRadioGroupOption[] {
    return [ADD_CONTRACT_NO, ADD_CONTRACT_YES];
  }

  private get isAddToOrganisationNoSelected() {
    return this.selectedOrganisationOption?.key === ADD_ORGANISATION_NO.key;
  }
  private get isAddToOrganisationYesSelected() {
    return this.selectedOrganisationOption?.key === ADD_ORGANISATION_YES.key;
  }
  private get isAddToProjectsNoSelected() {
    return this.selectedProjectOption?.key === ADD_PROJECT_NO.key;
  }
  private get isAddToProjectsYesSelected() {
    return this.selectedProjectOption?.key === ADD_PROJECT_YES.key;
  }
  private get isAddToContractsNoSelected() {
    return this.selectedContractOption?.key === ADD_CONTRACT_NO.key;
  }
  private get isAddToContractsYesSelected() {
    return this.selectedContractOption?.key === ADD_CONTRACT_YES.key;
  }

  // * WATCHERS

  // * METHODS

  public async validate() {
    blurCombos(
      this.$refs.emailAddressCombo,
      this.$refs.organisationJobTitleCombo,
      this.$refs.projectRoleTitleCombo,
      this.$refs.contractRoleTitleCombo,
    );

    // wait for a re-render so we absotively posilutely have the values where they should be
    await this.$nextTick();

    for (const project of this.selectedProjects) {
      // reset the errors from last time
      project.errorMessages = [];
    }
    for (const contract of this.selectedContracts) {
      // reset the errors from last time
      contract.errorMessages = [];
    }

    // run the standard validation first
    let isValid = this.formRef.validate();

    // then run our special validation next

    // only validate projects if they've said they want to validate projects
    // we don't care if they've said yes, picked a bunch of things that are bad, then said no
    if (this.isAddToProjectsYesSelected) {
      // make sure they've picked at least one project?
      // Do we really care if they've said yes, but then decided to not pick projects?
      // if they say yes to all three but don't pick anything, we'll tell them off further down

      // make sure that each project is unique
      // make sure they don't have any projects that the user cannot be invited to
      const projectCountByGid = this.selectedProjects.reduce((results, item) => {
        const gid = item.project?.data?.project?.gid;
        if (gid) {
          results.set(gid, (results.get(gid) || 0) + 1);
        }
        return results;
      }, new Map<string, number>());
      for (const project of this.selectedProjects) {
        // we're only interested in real projects
        if (project.project?.data) {
          if (project.project.data.alreadyAssociated) {
            project.errorMessages.push('Already associated with this Project');
            isValid = false;
          } else if ((projectCountByGid.get(project.project.data.project.gid) || 0) > 1) {
            project.errorMessages.push('Project must be unique');
            isValid = false;
          }
        }
      }
    }

    // only validate contracts if they've said they want to validate contracts
    // we don't care if they've said yes, picked a bunch of things that are bad, then said no
    if (this.isAddToContractsYesSelected) {
      // make sure they've picked at least one contract?
      // Do we really care if they've said yes, but then decided to not pick contracts?
      // if they say yes to all three but don't pick anything, we'll tell them off further down

      // make sure that each contract is unique
      // make sure they don't have any contracts that the user cannot be invited to
      const contractCountByGid = this.selectedContracts.reduce((results, item) => {
        const gid = item.contract?.data?.contract?.gid;
        if (gid) {
          results.set(gid, (results.get(gid) || 0) + 1);
        }
        return results;
      }, new Map<string, number>());
      for (const contract of this.selectedContracts) {
        // we're only interested in real contracts
        if (contract.contract?.data) {
          if (contract.contract.data.alreadyAssociated) {
            contract.errorMessages.push('Already associated with this Contract');
            isValid = false;
          } else if ((contractCountByGid.get(contract.contract.data.contract.gid) || 0) > 1) {
            contract.errorMessages.push('Contract must be unique');
            isValid = false;
          }
        }
      }
    }

    // make sure that each contract is unique
    // make sure they don't have any contract that the user cannot be invited to

    // make sure they've picked at least the org, a project or a contract
    // the org is troubling me
    // all of this is troubling me
    // ultimately, they need either the user for the org, or a project, or a contract.
    // they might not have permission to select any of them though
    // but that's probably a messaging concern, not a logic concern?

    // we can tell if they will not submitting any projects easily
    //   Not allowed to do it
    //   "No" radio option selected
    //   Nothing selected in the list
    //   we have to look at No selected because if they pick no, it doesn't matter what is in the list, nothing is being submitted
    const willNotBeSubmittingProjects =
      !this.canAddToProjects || this.isAddToProjectsNoSelected || this.selectedProjects.length === 0;

    // same for contracts
    const willNotBeSubmittingContracts =
      !this.canAddToContracts || this.isAddToContractsNoSelected || this.selectedContracts.length === 0;

    // we can tell if they will not be submitting an organisation if
    //   they're not allowed to
    //   they've picked the "no" radio option
    //   the user they've entered can't be submitted
    const willNotBeSubmittingAnOrganisation =
      !this.canAddToTargetOrganisation ||
      this.isAddToOrganisationNoSelected ||
      this.isAlreadyAssociatedWithTargetOrganisation;

    this.showMustSelectSomethingError =
      willNotBeSubmittingAnOrganisation && willNotBeSubmittingProjects && willNotBeSubmittingContracts;

    isValid = isValid && !this.showMustSelectSomethingError;

    return isValid;
  }

  public addProject() {
    this.selectedProjects.push(new AddToProject());
  }
  public addContract() {
    this.selectedContracts.push(new AddToContract());
  }
  private handleRemoveProject(project: AddToProject) {
    this.selectedProjects = this.selectedProjects.filter(x => x !== project);
  }
  private handleRemoveContract(contract: AddToContract) {
    this.selectedContracts = this.selectedContracts.filter(x => x !== contract);
  }

  private async getDocument() {
    const documentGid = this.documentGid;
    if (!documentGid) {
      console.error('associations -> getDocument -> documentGid is null');
      return null;
    }
    const result = await executeApi(() => this.api.documents().getDocument(documentGid), 'Load Document Details');
    if (result.success && result.data) {
      return DocumentDetails.createFromApiResponse(result.data);
    }
    return null;
  }

  private async getProjects() {
    const apiResponse = await executeApi(() => this.api.projects().getProjects(PermissionLevel.View), 'Load Projects');
    if (apiResponse.success && apiResponse.data?.projects) {
      return apiResponse.data.projects.map(s => Project.createFromApiResponse(s));
    }
  }

  private async getProfile() {
    return vxm.userProfile.getUserProfile();
  }

  private isLoading = false;
  private async initialise() {
    this.isLoading = true;

    // we probably don't need to ALWAYS load the projects
    // we could probably bypass the loading of the document if it's still the same document
    // but, until we can get finer grained flags into the calling of initialise (which is from reset and created)
    // then we're going to do it this way

    const [document, projects, profile] = await Promise.all([
      this.getDocument(),
      this.getProjects(),
      this.getProfile(),
    ]);

    // work out org stuff first
    console.log('associations -> initialise -> debug dump', {
      targetOrganisationGid: this.targetOrganisationGid,
      addToOrganisation: this.addToOrganisation,
      hasDocument: Boolean(document),
      hasDocumentOrgAssociations: Boolean(document && document.organisationAssociations),
      isAlreadyAssociatedWithTargetOrganisation: Boolean(
        document &&
          document.organisationAssociations &&
          document.organisationAssociations.some(x => areSame(x.organisationGid, this.targetOrganisationGid)),
      ),
    });
    this.isAlreadyAssociatedWithTargetOrganisation = Boolean(
      document &&
        document.organisationAssociations &&
        document.organisationAssociations.some(x => areSame(x.organisationGid, this.targetOrganisationGid)),
    );
    this.canAddToTargetOrganisation = Boolean(
      profile &&
        this.targetOrganisationGid &&
        profile.organisations.some(x => areSame(x.gid, this.targetOrganisationGid)),
    );

    const availableProjects: IAutocompleteItem<SelectableProject>[] = [];
    const availableContracts: IAutocompleteItem<SelectableContract>[] = [];
    const selectedProjects: AddToProject[] = [];
    const selectedContracts: AddToContract[] = [];

    if (projects) {
      for (const project of projects) {
        // wrong org, move onto the next one
        if (!areSame(project.organisationGid, this.targetOrganisationGid)) {
          continue;
        }
        // gotta be an active user of the project before you can add a document to it
        const canAddToProject = project.projectUser?.status === OtUserStatus.Active;
        // as above, but org users can also add to any projects
        if (canAddToProject || this.canAddToTargetOrganisation) {
          // this is a project they can try and associate with
          const theProject = new SelectableProject({
            project,
            alreadyAssociated: Boolean(
              document &&
                document.projectAssociations &&
                document.projectAssociations.some(x => areSame(x.projectGid, project.gid)),
            ),
          });

          const thisProject: IAutocompleteItem<SelectableProject> = {
            label: `${project.code}: ${project.name}`,
            data: theProject,
            disabled: theProject.alreadyAssociated,
          };
          availableProjects.push(thisProject);

          if (this.addToProjectGids.includes(project.gid)) {
            selectedProjects.push(
              new AddToProject({
                project: thisProject,
              }),
            );
          }
        }

        for (const contract of project.contracts) {
          // gotta be an active user of the contract to be able to add documents to it
          const canAddToContract = contract.contractUser?.status === OtUserStatus.Active;
          // as above, also project users can add to contracts under it, and org users can do what they want
          if (canAddToContract || canAddToProject || this.canAddToTargetOrganisation) {
            // this is a contract they can try and assocate with
            const theContract = new SelectableContract({
              contract,
              project,
              alreadyAssociated: Boolean(
                document &&
                  document.contractAssociations &&
                  document.contractAssociations.some(x => areSame(x.contractGid, contract.gid)),
              ),
            });
            const thisContract: IAutocompleteItem<SelectableContract> = {
              label: `${project.code}: ${project.name} - ${contract.reference}: ${contract.name}`,
              data: theContract,
              disabled: theContract.alreadyAssociated,
            };
            availableContracts.push(thisContract);
            if (this.addToContractGids.includes(contract.gid)) {
              selectedContracts.push(new AddToContract({ contract: thisContract }));
            }
          }
        }
      }
    }

    this.availableProjects = availableProjects;
    this.availableContracts = availableContracts;
    this.selectedProjects = selectedProjects;
    this.selectedContracts = selectedContracts;

    if (this.addToOrganisation) {
      this.selectedOrganisationOption = ADD_ORGANISATION_YES;
    } else {
      this.selectedOrganisationOption = ADD_ORGANISATION_NO;
    }

    if (this.selectedProjects.length) {
      this.selectedProjectOption = ADD_PROJECT_YES;
    } else {
      this.selectedProjectOption = ADD_PROJECT_NO;
      // empty item in the list is better when the user selects Yes
      this.selectedProjects = [new AddToProject({ key: uniqueId() })];
    }

    if (this.selectedContracts.length) {
      this.selectedContractOption = ADD_CONTRACT_YES;
    } else {
      this.selectedContractOption = ADD_CONTRACT_NO;
      // empty item in the list is better when the user selects Yes
      this.selectedContracts = [new AddToContract({ key: uniqueId() })];
    }

    this.isLoading = false;
  }

  public async submit(validate = true) {
    if (validate) {
      const isValid = await this.validate();
      if (!isValid) {
        return null;
      }
    }

    return new CreateDocumentAssociationsResult({
      addToOrganisation:
        this.canAddToTargetOrganisation &&
        this.isAddToOrganisationYesSelected &&
        !this.isAlreadyAssociatedWithTargetOrganisation,
      addToProjectGids:
        this.canAddToProjects && this.isAddToProjectsYesSelected
          ? // the as string[] is dumb here. We've already filtered out the undefineds, but the version of typescript in use
            // doesn't have that kind of smarts.
            (this.selectedProjects.map(x => x.project?.data?.project?.gid).filter(x => x !== undefined) as string[])
          : [],
      addToContractGids:
        this.canAddToContracts && this.isAddToContractsYesSelected
          ? // the as string[] is dumb here. We've already filtered out the undefineds, but the version of typescript in use
            // doesn't have that kind of smarts.
            (this.selectedContracts.map(x => x.contract?.data?.contract?.gid).filter(x => x !== undefined) as string[])
          : [],
    });
  }

  public async reset() {
    //   return this.initialise();
  }

  // * LIFECYCLE
  private async created() {
    // No. Don't do this at create time. This is used on a couple of dialogs, they're mounted in App.vue
    // if we try and initialise here, we try and make API calls before we're logged in. Instead, the dialogs both call reset
    // when they are opened (because that's what dialogs do, they're reusable), so we don't need to do anything here
    // await this.initialise();
  }

  private mounted() {
    // except, the above is nonsense. Yes, the dialogs do call reset, but there's @#$%ing ref issues I (Dan) do not understand
    // happening in create-document-associations. So, initialise here, in mounted.
    this.initialise();
  }
}
